@if (disabledSubsystems()?.length) {
  <div [class.disabled-subsystems-button-compact-mode]="isCompactModeActivated()">
    <button mat-button (click)="onClickDisabledSubsystems()">View disabled subsystems</button>
  </div>
}
